import React from 'react';
import './Logo.css';

const Logo = ({ size = 'medium' }) => {
  return (
    <div className={`logo ${size}`}>
      <img src="/logo.png" alt="Ria Logo" className={`logo-img ${size}`} />
<span className="logo-text">Ria</span>
    </div>
  );
};

export default Logo; 